<template>
  <div>
    <Banner :classType="1" />
    <Menu />
    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>发展历程</h2>
      <p>DEVELOPMENT HISTORY</p>
    </div>
    <div class="wow animate__slideInUp">
      <TimeLine :ContentInfos="ContentInfos2" v-if="lang=='en'"/>
      <TimeLine2 :ContentInfos="ContentInfos" v-else/>
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";
import Menu from "./Menu.vue";
import TimeLine from "@/views/components/TimeLine";
import TimeLine2 from "@/views/components/TimeLine2";
import { WOW } from "wowjs";

export default {
  data() {
    return {
      ContentInfos: [],
      ContentInfos2: [],
      lang: this.$global.lang,
    };
  },
  components: {
    Banner,
    Menu,
    TimeLine,
    TimeLine2,
  },
  created() {
    this.lang = cookie.get("lang");
  },
  methods: {
    getUse() {
      this.$api.deveList({ Type: 3 }).then((res) => {
        const { DevelopmentInfos } = res.Value;
        this.ContentInfos = DevelopmentInfos;
        this.$nextTick(() => {
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            offset: 100,
            live: false,
          }).init();
        });
      });
    },
    getUse2() {
      this.$api.rearch({ Type: 3 }).then((res) => {
        const { ContentInfos } = res.Value;
        this.ContentInfos2 = ContentInfos;
        console.log(this.ContentInfos2,'23++')
        this.$nextTick(() => {
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            offset: 100,
            live: false,
          }).init();
        });
      });
    },
  },
  mounted() {
    this.getUse();
    this.getUse2();
  },
};
</script>


